export const uniqueKey = (prefix = '_'): string =>
  `${prefix}${Date.now()}${Math.random()}`.replace('.', '');
